import * as React from "react";

const { Component } = React;

import { createOrSaveIntegration } from "../IntegrationStore";
import { alert } from "../../general/alertStore.js";
import IntegrationTrigger from "../IntegrationTrigger";

import axios from "../../general/HttpClient";
import { GetContext, UnsubscribeContext } from "../../general/ApplicationContext";
import { Input } from "reactstrap";
import { ADAMIntegration } from "./ADAMStore.js";


interface ADAMState {
    profiles: Array<ADAMIntegration>;
    users: any;
    selectedProfile: ADAMIntegration;
    selectedProfileId: string;
    syncResult: any;
}

interface ADAMProps {
    organization: string;
}

let contextSubscriptionId = "";

export default class ImportADAMStudents extends Component<ADAMProps, ADAMState> {
    constructor(props) {
        super(props);

        this.state = {
            profiles: [],
            users: [],
            selectedProfile: new ADAMIntegration(),
            selectedProfileId: "",
            syncResult: undefined,
        };
    }

    saveProfile = () => {
        if (this.state.selectedProfile.name) {
            this.setState(
                (prevState) => {
                    prevState.selectedProfile.integrationDirection = 0; //In
                    prevState.selectedProfile.integrationType = 11; //ADAM
                    prevState.selectedProfile.organizationId = this.props.organization;

                    return prevState;
                },
                () => {
                    createOrSaveIntegration(this.state.selectedProfile).then(() => {
                        this.getProfiles();
                    });
                }
            );
        }
    };

    syncUsers = () => {
        axios.post(`/api/Integrations/${this.state.selectedProfileId}/ImportStaffUsersFromADAM`, this.state.selectedProfile.config).then(
            (response) => {
                alert({
                    type: "alert-success",
                    text: `Users synced successfully`,
                });
                this.setState({ syncResult: response.data });
            },
            (response) => {
                this.setState({ syncResult: response.data });
            }
        );
    };

    componentDidMount() {
        contextSubscriptionId = GetContext((context) => {
            this.getProfiles();
        });
    }

    componentWillUnmount() {
        UnsubscribeContext(contextSubscriptionId);
    }

    getProfiles = () => {
        axios
            .get(`/api/Integrations/Types/11?organizationId=${this.props.organization}`) //ADAM
            .then((response) => {
                this.setState({ profiles: response.data, selectedProfile: new ADAMIntegration(), selectedProfileId: "" });
            });
    };

    handleProfileChange = (e) => {
        let id = e.target.value;
        this.setState((prevState) => ({ selectedProfileId: id, selectedProfile: new ADAMIntegration(prevState.profiles.filter((profile) => profile.integrationId == id)[0]) }));
    };

    handleNameChange = (e) => {
        let name = e.target.value;
        this.setState((prevState) => {
            prevState.selectedProfile.name = name;
            return prevState;
        });
    };

    handlePriorityChange = (e) => {
      let priority = e.target.valueAsNumber;
      this.setState((prevState) => {
          prevState.selectedProfile.priority = priority;
          return prevState;
      });
  };

    handleADAMUrlChange = (e) => {
        let url = e.target.value;
        this.setState((prevState) => {
            prevState.selectedProfile.config.url = url;
            return prevState;
        });
    };

    handleApiKeyChange = (e) => {
        let apiKey = e.target.value;
        this.setState((prevState) => {
            prevState.selectedProfile.config.apiKey = apiKey;
            return prevState;
        });
    };

    handleUsernameChange = (e) => {
        let username = e.target.value;
        this.setState((prevState) => {
            prevState.selectedProfile.config.username = username;
            return prevState;
        });
    };

    handlePasswordChange = (e) => {
        let password = e.target.value;
        this.setState((prevState) => {
            prevState.selectedProfile.config.password = password;
            return prevState;
        });
    };

    handleDomainChange = (e) => {
        let domain = e.target.value;
        this.setState((prevState) => {
            prevState.selectedProfile.config.domain = domain;
            return prevState;
        });
    };

    render() {
        return (
            <div>
                <h3>ADAM Users</h3>
                <div className="row">
                    <div className="col-12">
                        <div className="form-group row">
                            <label className="col-xs-12 col-md-3 col-form-label">Profile</label>
                            <div className="col-xs-12 col-md-9 pl-0">
                                <Input type="select" onChange={this.handleProfileChange} value={this.state.selectedProfileId}>
                                    <option>Please Select</option>
                                    {this.state.profiles.map((profile) => (
                                        <option key={profile.integrationId} value={profile.integrationId}>
                                            {profile.name}
                                        </option>
                                    ))}
                                </Input>
                            </div>
                        </div>
                    </div>
                    {this.state.selectedProfileId && (
                        <div className="col-12">
                            <IntegrationTrigger integration={this.state.selectedProfile}></IntegrationTrigger>
                        </div>
                    )}
                    <div className="col-xs-12 col-md-6">
                        <div className="form-group row">
                            <label className="col-xs-12 col-md-3 col-form-label">Profile Name</label>
                            <div className="col-xs-12 col-md-9 pl-0">
                                <input type="text" className="form-control" value={this.state.selectedProfile.name} onChange={this.handleNameChange} />
                            </div>
                        </div>
                    </div>
                    {this.state.selectedProfileId && (
                        <div className="col-xs-12 col-md-6">
                            <div className="form-group row">
                                <label className="col-xs-12 col-md-3 col-form-label">Priority (lower first)</label>
                                <div className="col-xs-12 col-md-9 pl-0">
                                    <input type="number" className="form-control" value={this.state.selectedProfile.priority} onChange={this.handlePriorityChange} />
                                </div>
                            </div>
                        </div>
                    )}
                    {!this.state.selectedProfileId && (
                        <div className="col-xs-12 col-md-6">
                            <div className="d-flex align-items-end flex-column pt-4">
                                <div className="mt-auto">
                                    <button className="btn btn-success me-1" type="button" onClick={this.saveProfile}>
                                        Create Profile
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
                {this.state.selectedProfileId && (
                    <div>
                        <div className="row">
                            <div className="col-xs-12 col-md-6">
                                <div className="form-group row">
                                    <label className="col-xs-12 col-md-3 col-form-label">ADAM URL</label>
                                    <div className="col-xs-12 col-md-9 pl-0">
                                        <input type="text" className="form-control" value={this.state.selectedProfile.config.url} onChange={this.handleADAMUrlChange} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-xs-12 col-md-6">
                                <div className="form-group row">
                                    <label className="col-xs-12 col-md-3 col-form-label">Domain</label>
                                    <div className="col-xs-12 col-md-9 pl-0">
                                        <input type="text" className="form-control" value={this.state.selectedProfile.config.domain} onChange={this.handleDomainChange} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-xs-12 col-md-6">
                                <div className="form-group row">
                                    <label className="col-xs-12 col-md-3 col-form-label">API Key</label>
                                    <div className="col-xs-12 col-md-9 pl-0">
                                        <input type="text" className="form-control" value={this.state.selectedProfile.config.apiKey} onChange={this.handleApiKeyChange} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-xs-12 col-md-6">
                                <div className="form-group row">
                                    <label className="col-xs-12 col-md-3 col-form-label">Username</label>
                                    <div className="col-xs-12 col-md-9 pl-0">
                                        <input type="text" className="form-control" value={this.state.selectedProfile.config.username} onChange={this.handleUsernameChange} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-xs-12 col-md-6">
                                <div className="form-group row">
                                    <label className="col-xs-12 col-md-3 col-form-label">Password</label>
                                    <div className="col-xs-12 col-md-9 pl-0">
                                        <input type="text" className="form-control" value={this.state.selectedProfile.config.password} onChange={this.handlePasswordChange} />
                                    </div>
                                </div>
                            </div>

                            <div className="col-xs-12 col-md-6">
                                <div className="d-flex align-items-end flex-column pt-4">
                                    <div className="mt-auto">
                                        <button className="btn btn-success me-1" type="button" onClick={this.saveProfile}>
                                            Save Profile
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <div className="d-flex align-items-end flex-column pt-4">
                                    <div className="mt-auto">
                                        <button className="btn btn-primary" type="button" onClick={this.syncUsers}>
                                            Sync
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-12">
                                {this.state.syncResult && (
                                    <div>
                                        <a href={`/hangfire/jobs/details/${this.state.syncResult}`}>Background Job Created</a>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}
